import { render, staticRenderFns } from "./EffortParticipants.vue?vue&type=template&id=023dc4bc&scoped=true&"
import script from "./EffortParticipants.vue?vue&type=script&lang=js&"
export * from "./EffortParticipants.vue?vue&type=script&lang=js&"
import style0 from "./EffortParticipants.vue?vue&type=style&index=0&id=023dc4bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dc4bc",
  null
  
)

export default component.exports